module.exports = __webpack_public_path__ + "img/Award.8fc03a20.jpg";